$(function () {
    const $bottomBar = $('#bottom-bar');

    if (! $bottomBar.length) {
        return;
    }

    const $bottomBarCollapse = $bottomBar.find('.accordion-collapse');
    const $bottomBarBody = $bottomBarCollapse.find('.accordion-body');
    const $bottomBarInput = $bottomBarBody.find(':input').first();
    const $bottomBarResizeHandle = $bottomBar.find('.bottom-bar-resize-handle');

    // Focus input when shown
    if ($bottomBarInput.length) {
        $bottomBarCollapse.on('shown.bs.collapse', function () {
            $bottomBarInput.trigger('focus');
        });
    }

    // Resize handle
    $bottomBarResizeHandle.on('pointerdown', function (downEvent) {
        downEvent.preventDefault();

        const pointerHandlers = {
            pointermove: function (event) {
                const height = $bottomBar[0].getBoundingClientRect().bottom
                    - event.clientY
                    - $bottomBarBody.position().top;

                $bottomBarBody.height(height);
            },
            pointerup: function () {
                $bottomBarResizeHandle[0].releasePointerCapture(downEvent.pointerId);
                $bottomBarResizeHandle.off(pointerHandlers);
            },
        };

        pointerHandlers.pointermove(downEvent);
        $bottomBarResizeHandle[0].setPointerCapture(downEvent.pointerId);
        $bottomBarResizeHandle.on(pointerHandlers);
    });
});
